import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthEvents {
  private authSessionExpired$ = new Subject<void>();

  get onAuthSessionExpired$(): Observable<void> {
    return this.authSessionExpired$.asObservable();
  }

  setAuthSessionExpired(): void {
    this.authSessionExpired$.next();
  }
}
